import styled from 'styled-components';

export const Styled = styled.hr<{ newUi?: boolean }>`
  height: 1px;
  background-color: ${(newUi) => (newUi ? 'var(--color-indigo-t1)' : '#d9d9d9')};
  border: none;
  margin: 40px 0;
`;
